<div mat-dialog-content class="loading-modal" fxLayout="row" fxLayoutAlign="center center">
  <mat-spinner class="loading-spinner" [diameter]="30"></mat-spinner>
  <span class="label">{{this.data}}...</span>
</div>
